<template>
    <div class="page">
        <h1 class="text_13 page__title">{{ $t("manifest") }}</h1>
        <div class="page__content">
            <div class="container">
                <div class="row">
                    <div class="col sm-12 col--no-padding lg-6 col--centered text_15 manifest" v-html="text">
                        <table>
                            <tr>
                                <td><div style="align: right"></div></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "Manifest",
    head() {
        return {
            title: this.$i18n.t("manifest") + " | " + this.$i18n.t("pps_title"),
            meta: this.meta,
        };
    },
    async asyncData({ $axios }) {
        const text = await $axios.get("/api/pages/manifest");
        const data = {
            text: text.data.data.text,
        };
        return data;
    },
    data() {
        return {
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.$i18n.t("text_manifest"),
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.$i18n.t("text_manifest"),
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        crumbs() {
            return [{ name: this.$i18n.t("manifest") }];
        },
    },
    watch: {
        async langust() {
            await this.$nuxt.refresh();
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
    },
};
</script>
<style lang="less">
.manifest {
    padding: 96px 0;
    @media @sm {
        padding: 24px 0 56px;
    }
    table {
        tr {
            @media @sm {
                display: block;
            }
        }
        td {
            padding: 0 @spacer;
            @media @sm {
                display: block;
                width: 100% !important;
                padding: 0 16px;
            }
            + td {
                color: @text_2;
                @media @sm {
                    margin-top: 16px;
                }
            }
            p + p {
                display: block;
                margin-top: 10px;
            }
            div[style*="align: right"] {
                padding-top: 64px;
                color: #000;
                font-size: 17px;
                line-height: 140%;
                letter-spacing: 0.16em;
                position: absolute;
                @media @sm {
                    padding-top: 0;
                    margin-top: -16px;
                    position: static;
                }
            }
        }
    }
}
</style>
